import styled from 'styled-components';
import { Link } from 'react-router-dom';
import S from '../UI/variables';

export const StyledObjectsCardset = styled.ul`
  display: flex;
  flex-wrap: wrap;
  padding-top: ${props => props.paddingTop || '65px'};
  justify-content: center;
  & > li {
    width: 100%;
    max-width: 480px;
  }
  & > li:not(:last-child) {
    margin-bottom: 14px;
  }
  @media screen and (min-width: ${S.tablet}) {
    & > li {
      width: calc((100% - 19px) / 2);
      margin-bottom: 24px;
    }
    & > li:nth-last-child(-n + 2) {
      margin-bottom: 0;
    }
    & > li:nth-child(2n - 1) {
      margin-right: 19px;
    }
    & > li:last-child {
      margin-right: 0;
    }
  }
  @media screen and (min-width: ${S.desktop}) {
    & > li {
      width: calc((100% - 38px) / 3);
      margin-right: 19px;
    }
    & > li:nth-last-child(-n + 3) {
      margin-bottom: 0;
    }
    & > li:nth-child(3n) {
      margin-right: 0;
    }
    & > li:last-child {
      margin-right: 0;
    }
  }
`;

export const StyledObjectsCard = styled.li`
  position: relative;
  display: flex;
  flex-direction: column;
  background: #fff;
  box-shadow: ${S.recentsCardShade};
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;
  height: fit-content;
  & > .copy {
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 10px;
    border-radius: 5px;
    background: ${S.overlay};
    color: white;
    font-size: 12px;
    line-height: 1.4em;
    border: 1px solid ${S.mainBlackText};
    border-top-color: ${S.mainBorder};
    border-left-color: ${S.mainBorder};
    @media screen and (min-width: ${S.desktop}) {
      opacity: 0;
      pointer-events: none;
    }
    transition: opacity ${S.trSlow} 250ms;
  }
  &:hover {
    box-shadow: ${S.recentsCardHoverShade};
    & > .copy {
      pointer-events: auto;
      opacity: 1;
    }
  }
  transition: box-shadow ${S.trFast};
  @media screen and (min-width: ${S.tablet}) {
  }
  & > picture {
    height: 190px;
    & > img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
    @media screen and (min-width: ${S.tablet}) {
      height: 300px;
    }
  }
`;

export const StyledCardInfo = styled.article`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const StyledBrokerInfo = styled.div`
  position: absolute;
  top: -40px;
  width: 100%;
  height: 40px;
  background: #fff;
  padding: 0 20px;

  & > picture {
    position: absolute;
    bottom: 14px;
    left: 20px;
  }
  & > .wrap {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    padding-left: 60px;
    border-bottom: 1px solid ${S.secondaryBorder};
  }
  & .image {
    display: block;
    width: 48px;
    height: 48px;
    object-fit: cover;
    overflow: hidden;
    border-radius: 50%;
  }
  & .broker__name {
    font-size: 16px;
    color: ${S.goldenText};
    font-weight: 700;
    font-family: 'Judson', serif;
  }
`;

export const StyledCardInfoDetails = styled.div`
  display: flex;
  padding: 6px 0;
`;

export const StyledCardInfoDetail = styled.div`
  height: 27px;
  width: calc(100% / 3);
  font-size: 10px;
  text-align: center;
  display: flex;
  padding: 0 4px;
  & > span {
    margin: auto;
    display: block;
  }
  &:not(:last-child) {
    border-right: 1px solid ${S.secondaryBorder};
  }
  @media screen and (min-width: ${S.tablet}) {
    height: 34px;
    font-size: 12px;
  }
`;

export const StyledCardTitle = styled.div`
  padding: 0 17px;
  & > div {
    height: 132px;
    padding-top: 8px;
    border-bottom: 1px solid ${S.secondaryBorder};
    border-top: 1px solid ${S.secondaryBorder};
  }
  & h4 {
    font-size: 18px;
    font-weight: 400;
    line-height: 1.4em;
    margin-bottom: 22px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    height: 78px;
    overflow: hidden;
  }
  & h5 {
    font-size: 12px;
    font-weight: 400;
    color: ${S.secondaryGreyText};
  }
  @media screen and (min-width: ${S.tablet}) {
    & > div {
      padding-top: 16px;
    }
    & h4 {
      font-size: 20px;
      height: 50px;
      margin-bottom: 30px;
      -webkit-line-clamp: 2;
    }
    & h5 {
      font-size: 18px;
    }
  }
`;

export const StyledCardPrice = styled.div`
  padding: 0 17px;
  display: flex;
  align-items: center;
  & > .price {
    display: flex;
    align-items: center;
    height: 56px;
    color: ${S.redText};
    font-size: 20px;
    font-weight: 600;
    width: 100%;
    & > .price--per-m {
      font-size: 14px;
      border-left: 1px solid ${S.mainBlackText};
      color: ${S.mainBlackText};
      padding-left: 14px;
      margin-left: 16px;
    }
    @media screen and (min-width: ${S.tablet}) {
      height: 72px;
      font-size: 24px;
      & > .price--per-m {
        font-size: 18px;
      }
    }
  }
`;

export const StyledCardMore = styled(Link)`
  display: none;
  cursor: pointer;
`;

export const StyledTeamCardsetWrapper = styled.div`
  position: relative;
`;

export const StyledTeamCardset = styled.ul`
  display: flex;
  height: 100%;
  width: fit-content;
  & > li {
    width: calc(100vw - 60px);
  }
  & > li:not(:last-child) {
    margin-right: 20px;
  }
  @media screen and (min-width: ${S.tablet}) {
    & > li {
      width: calc((100vw - 80px) / 2);
    }
  }
  @media screen and (min-width: ${S.desktop}) {
    & > li {
      width: calc((100vw - 100px) / 3);
      max-width: calc(1240px / 3);
    }
  }
  transition: transform ${S.trFast};
`;

export const StyledBrokersCardset = styled.ul`
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  width: 100%;
  & > li {
    width: 100%;
    margin-bottom: 20px;
  }
  @media screen and (min-width: ${S.tablet}) {
    & > li {
      width: calc((100% - 20px) / 2);
      margin-right: 20px;
    }
    & > li:nth-child(2n) {
      margin-right: 0;
    }
  }
  transition: transform ${S.trFast};
`;

export const StyledTeamSlider = styled.div`
  width: 100%;
  height: 300px;
  @media screen and (min-width: ${S.tablet}) {
    height: 250px;
  }
  overflow: hidden;
`;

export const StyledIndicators = styled.ul`
  display: flex;
  width: fit-content;
  margin: 30px auto 0;
  & .indicator {
    width: 12px;
    height: 12px;
    background: ${S.inactiveIndicator};
    border-radius: 6px;
    transition: background ${S.trFast};
    &:not(:last-child) {
      margin-right: 28px;
    }
    &.active {
      background: ${S.activeIndicator};
    }
  }
`;

export const StyledTeamCard = styled.li`
  background: #fff;
  border-radius: 10px;
  box-shadow: ${S.userCardShade};
  padding: 20px 40px 30px 16px;
  & .card {
    display: flex;
    width: 100%;
  }

  & .card__photo {
    width: 72px;
    height: 72px;
    overflow: hidden;
    border-radius: 50%;
    margin-right: 16px;
    flex-shrink: 0;
    & img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
  & .card__content {
    width: calc(100% - 88px);
  }
  & .card__address {
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
    & > a {
      color: ${S.mainBlackText};
      font-style: normal;
      &:not(:last-child) {
        margin-bottom: 12px;
      }
      font-size: 12px;
      @media screen and (min-width: ${S.tablet}) {
        font-size: 16px;
      }
    }
  }
  & .card__title {
    font-family: 'Judson', serif;
    font-weight: 700;
    font-size: 20px;
    color: ${S.goldenText};
    margin-bottom: 12px;
    @media screen and (min-width: ${S.tablet}) {
      font-size: 24px;
    }
  }
  & .card__text {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5em;
    color: ${S.cardGreyText};
    @media screen and (min-width: ${S.tablet}) {
      font-size: 16px;
    }
  }
`;

export const StyledTeamControls = styled.div`
  position: absolute;
  top: 50%;
  display: none;
  width: 40px;
  height: 40px;
  background: #fff;
  cursor: pointer;
  border-radius: 50%;
  box-shadow: ${S.controlsShade};
  & > .icon {
    pointer-events: none;
    margin: auto;
  }
  &.left {
    left: 0;
    transform: translate(-50%, -100%);
  }
  &.right {
    right: 0;
    transform: translate(50%, -100%);
    & > .icon {
      transform: rotate(180deg);
    }
  }
  &.inactive {
    opacity: 0;
    pointer-events: none;
  }
  @media screen and (min-width: ${S.tablet}) {
    display: flex;
  }
  transition: opacity ${S.trSlow};
`;

export const StyledMoreButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 14px;
  @media screen and (min-width: ${S.tablet}) {
    margin-top: 44px;
  }
  & > button {
    @media screen and (min-width: ${S.tablet}) {
      width: calc((100% - 19px) / 2);
    }
    @media screen and (min-width: ${S.desktop}) {
      width: calc((100% - 38px) / 3);
    }
  }
  & > div:not(:last-child) {
    margin-right: 8px;
  }
  & > .dots {
  }
`;

export const StyledStateLabelWrapper = styled.ul`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 5px 0 5px 0;
  display: flex;
  overflow: hidden;
  & > li {
    width: fit-content;
    flex-grow: 1;
    flex-shrink: 0;
    font-size: 10px;
    text-transform: uppercase;
    padding: 12px;
    color: #fff;
    background: ${S.blueLabel};
    &.sold {
      background: ${S.redLabel};
    }
    &.reserved {
      background: ${S.orangeLabel};
    }
    &.unique {
      background: ${S.purpleLabel};
    }
    &.new {
      background: ${S.greenLabel};
    }
  }
`;

export const StyledSelectButton = styled.div`
  position: absolute;
  top: 12px;
  right: 4px;
`;
